import React, {useEffect, useState, useRef}from "react";
import { useCookies } from 'react-cookie';

const regex = new RegExp('^[A-Z]{1,4}$');
const regex2 = new RegExp('^[a-z]$');
const ForbSymb = ["|", "\\"];

export const LoginForm_Code = (props) => {
    const refName = useRef(null);
    const refRCode = useRef(null);
    const [RoomCode, setRoomCode] = useState("");
    const [PlayerName, setPlayerName] = useState("");
    const [cookies, setcookie, removecookie] = useCookies(['nickname', 'lastpid', 'lastrcode, playerplace, playercolor']);
    useEffect(() => {
        const elementName = refName.current;
        //console.log(element);
        if(cookies['nickname'] !== undefined) {elementName.value = cookies['nickname']; setPlayerName(cookies['nickname']);}
    }, []);
    const getRoom = (globState) => {
        console.log("Имя - " + globState["PlayerName"] + " Код - " + globState["RoomCode"]);
    }
    return(
    <form>
    <input className="FormInput" placeholder="Имя игрока" ref={refName}  onChange={(e) => 
        {
            if(e.target.value.length > 12) e.target.value = e.target.value.slice(0, -1);
            if(ForbSymb.includes(e.target.value[e.target.value.length-1])) e.target.value = e.target.value.slice(0, -1);
            setPlayerName(e.target.value);
        }
    }
    onKeyDown={(e) =>{if(e.key === "Enter") 
    {
        props.ChangeRCode(props.RCode, PlayerName);
    }
    }}
    ></input>
    <br />
    <div className="SubmitButton">
    <button type="button"  onClick={(e) => 
        {
            props.ChangeRCode(props.RCode, PlayerName);
        }}>Вход</button>
    </div>
    </form>
        );
}